import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./firebase";
import secureLocalStorage from "react-secure-storage";
import Cookies from "js-cookie";

const getFCMToken = async () => {
  if (!messaging) return null;
  const token = await getToken(messaging, {
    vapidKey:
      "BMYaC3_2Kv_AXwCMcXitE-W0kNxt6tMLPmMRkZNL8jvkqdJaWHFmYtV7aI1IA3imrSJyb9ne7An7yULYdYXKSMM",
  });
  if (token) {
    secureLocalStorage.setItem(process.env.REACT_APP_FCM_TOKEN_KEY, token);
    Cookies.set(process.env.REACT_APP_FCM_TOKEN_KEY, token);
  }

  console.log("FCM Token:", token);

  // 👉 Send token to backend here
  return token;
};
export const listenForegroundMessage = () => {
  if (!messaging) return;
  onMessage(messaging, (payload) => {
    console.log("Foreground message received:", payload);

    if (Notification.permission === "granted") {
      new Notification(payload.notification.title, {
        body: payload.notification.body,
        icon: "/logo192.png",
      });
    }
  });
};
export const requestNotificationPermission = async () => {
  // No push support here (plain http, iOS Safari without the Push API, etc.).
  if (!messaging || typeof Notification === "undefined") return null;
  try {
    // Already decided earlier
    if (Notification.permission === "granted") {
      return await getFCMToken();
    }

    if (Notification.permission === "denied") {
      // alert(
      //   "Notifications are blocked. Please enable them from browser settings."
      // );
      return null;
    }

    // Ask browser permission
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.log("User declined notification permission");
      return null;
    }

    return await getFCMToken();
  } catch (error) {
    console.error("Error getting notification permission", error);
    return null;
  }
};
